import * as turf from '@turf/turf';

export type FieldBounds = turf.BBox;

const isValidBounds = (bounds: number[]): bounds is FieldBounds => {
  if (bounds.length !== 4) {
    return false;
  }

  const [west, south, east, north] = bounds;

  if (![west, south, east, north].every(Number.isFinite)) {
    return false;
  }

  if (west > east || south > north) {
    return false;
  }

  return true;
};

export const getFieldBounds = (fieldBoundary: any): FieldBounds | undefined => {
  if (!fieldBoundary?.features?.length) {
    return undefined;
  }

  try {
    const bounds = turf.bbox(fieldBoundary);

    if (!isValidBounds(bounds)) {
      return undefined;
    }

    return bounds;
  } catch {
    return undefined;
  }
};
